module.exports = __webpack_public_path__ + "img/9.0850bc62.png";